export const getLocationAddress = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value.trim();
  if (typeof value !== 'object' || Array.isArray(value)) return '';
  return String(value.address || value.formatted_address || value.formattedAddress || '').trim();
};

export const normalizeLocationValue = (value) => {
  if (!value) return null;
  if (typeof value === 'string') {
    const address = value.trim();
    return address ? { address } : null;
  }
  if (typeof value !== 'object' || Array.isArray(value)) return null;
  const address = getLocationAddress(value);
  const formattedAddress = String(value.formatted_address || value.formattedAddress || address || '').trim();
  const placeId = String(value.place_id || value.placeId || '').trim();
  const lat = value.lat ?? value.latitude;
  const lng = value.lng ?? value.lon ?? value.longitude;
  const normalized = {};
  if (address) normalized.address = address;
  if (formattedAddress && formattedAddress !== address) normalized.formatted_address = formattedAddress;
  if (placeId) normalized.place_id = placeId;
  if (lat !== undefined && lat !== null && lat !== '') {
    const parsedLat = Number(lat);
    if (Number.isFinite(parsedLat)) normalized.lat = parsedLat;
  }
  if (lng !== undefined && lng !== null && lng !== '') {
    const parsedLng = Number(lng);
    if (Number.isFinite(parsedLng)) normalized.lng = parsedLng;
  }
  return Object.keys(normalized).length > 0 ? normalized : null;
};

export const locationToComparable = (value) => {
  const normalized = normalizeLocationValue(value);
  return normalized ? JSON.stringify(normalized) : '';
};
